import Head from 'next/head';
import Script from 'next/script';
import PropTypes from 'prop-types';

const ContainedHead = ({
  path,
  title,
  description,
  ogImage,
  ogDescription,
}) => {
  if (!title || !path) return '';
  const url = `${
    process.env.NEXT_PUBLIC_STOREFRONT_URL || 'https://aftershockpc.com.au'
  }${path || ''}`;
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta key="og:title" property="og:title" content={title} />
        {description && <meta name="description" content={description} />}
        {ogDescription && (
          <meta
            key="og:description"
            property="og:description"
            content={ogDescription}
          />
        )}
        {ogImage && (
          <>
            <meta
              property="og:image"
              content={
                ogImage?.url
                  ? ogImage.url
                  : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
              }
            />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1024" />
            <meta property="og:image:height" content="1024" />
          </>
        )}
        <meta key="og:url" property="og:url" content={url} />
        <meta name="twitter:site" content={url} />
      </Head>
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        strategy="lazyOnload"
      />
    </>
  );
};
ContainedHead.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

ContainedHead.defaultProps = {
  description: null,
};

export default ContainedHead;
